/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as DemoDisallowedRouteImport } from './routes/demo/disallowed'
import { Route as AuthVerifyCodeRouteImport } from './routes/auth/verify-code'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthGuestSignupRouteImport } from './routes/auth/guest-signup'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppUserSettingsIndexRouteImport } from './routes/_app/user-settings/index'
import { Route as AppPricingIndexRouteImport } from './routes/_app/pricing/index'
import { Route as AppMyProfileIndexRouteImport } from './routes/_app/my-profile/index'
import { Route as AppMeetingsIndexRouteImport } from './routes/_app/meetings/index'
import { Route as AppLiveMonitorsAlertsIndexRouteImport } from './routes/_app/live-monitors-alerts/index'
import { Route as AppLinkedAccountsIndexRouteImport } from './routes/_app/linked-accounts/index'
import { Route as AppCreateABotIndexRouteImport } from './routes/_app/create-a-bot/index'
import { Route as AppCompanyIndexRouteImport } from './routes/_app/company/index'
import { Route as AppAdminUtterancesIndexRouteImport } from './routes/_app/admin-utterances/index'
import { Route as AppUsersIdRouteImport } from './routes/_app/users/$id'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings_.billing'
import { Route as AppMeetingsSharedRouteImport } from './routes/_app/meetings/shared'
import { Route as AppMeetingsScheduledRouteImport } from './routes/_app/meetings/scheduled'
import { Route as AppCallbackZoomRouteImport } from './routes/_app/callback/zoom'
import { Route as AppMeetingsMeetingIdIndexRouteImport } from './routes/_app/meetings/$meetingId/index'
import { Route as AppMeetingsMeetingIdParticipantDetailsParticipantIdRouteImport } from './routes/_app/meetings/$meetingId/participant-details/$participantId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const DemoDisallowedRoute = DemoDisallowedRouteImport.update({
  id: '/demo/disallowed',
  path: '/demo/disallowed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyCodeRoute = AuthVerifyCodeRouteImport.update({
  id: '/verify-code',
  path: '/verify-code',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGuestSignupRoute = AuthGuestSignupRouteImport.update({
  id: '/guest-signup',
  path: '/guest-signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppUserSettingsIndexRoute = AppUserSettingsIndexRouteImport.update({
  id: '/user-settings/',
  path: '/user-settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppPricingIndexRoute = AppPricingIndexRouteImport.update({
  id: '/pricing/',
  path: '/pricing/',
  getParentRoute: () => AppRoute,
} as any)
const AppMyProfileIndexRoute = AppMyProfileIndexRouteImport.update({
  id: '/my-profile/',
  path: '/my-profile/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIndexRoute = AppMeetingsIndexRouteImport.update({
  id: '/meetings/',
  path: '/meetings/',
  getParentRoute: () => AppRoute,
} as any)
const AppLiveMonitorsAlertsIndexRoute =
  AppLiveMonitorsAlertsIndexRouteImport.update({
    id: '/live-monitors-alerts/',
    path: '/live-monitors-alerts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppLinkedAccountsIndexRoute = AppLinkedAccountsIndexRouteImport.update({
  id: '/linked-accounts/',
  path: '/linked-accounts/',
  getParentRoute: () => AppRoute,
} as any)
const AppCreateABotIndexRoute = AppCreateABotIndexRouteImport.update({
  id: '/create-a-bot/',
  path: '/create-a-bot/',
  getParentRoute: () => AppRoute,
} as any)
const AppCompanyIndexRoute = AppCompanyIndexRouteImport.update({
  id: '/company/',
  path: '/company/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUtterancesIndexRoute = AppAdminUtterancesIndexRouteImport.update({
  id: '/admin-utterances/',
  path: '/admin-utterances/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/settings_/billing',
  path: '/settings/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsSharedRoute = AppMeetingsSharedRouteImport.update({
  id: '/meetings/shared',
  path: '/meetings/shared',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsScheduledRoute = AppMeetingsScheduledRouteImport.update({
  id: '/meetings/scheduled',
  path: '/meetings/scheduled',
  getParentRoute: () => AppRoute,
} as any)
const AppCallbackZoomRoute = AppCallbackZoomRouteImport.update({
  id: '/callback/zoom',
  path: '/callback/zoom',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsMeetingIdIndexRoute =
  AppMeetingsMeetingIdIndexRouteImport.update({
    id: '/meetings/$meetingId/',
    path: '/meetings/$meetingId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMeetingsMeetingIdParticipantDetailsParticipantIdRoute =
  AppMeetingsMeetingIdParticipantDetailsParticipantIdRouteImport.update({
    id: '/meetings/$meetingId/participant-details/$participantId',
    path: '/meetings/$meetingId/participant-details/$participantId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/analytics': typeof AppAnalyticsRoute
  '/settings': typeof AppSettingsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/guest-signup': typeof AuthGuestSignupRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/verify-code': typeof AuthVerifyCodeRoute
  '/demo/disallowed': typeof DemoDisallowedRoute
  '/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/callback/zoom': typeof AppCallbackZoomRoute
  '/meetings/scheduled': typeof AppMeetingsScheduledRoute
  '/meetings/shared': typeof AppMeetingsSharedRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/users/$id': typeof AppUsersIdRoute
  '/admin-utterances': typeof AppAdminUtterancesIndexRoute
  '/company': typeof AppCompanyIndexRoute
  '/create-a-bot': typeof AppCreateABotIndexRoute
  '/linked-accounts': typeof AppLinkedAccountsIndexRoute
  '/live-monitors-alerts': typeof AppLiveMonitorsAlertsIndexRoute
  '/meetings': typeof AppMeetingsIndexRoute
  '/my-profile': typeof AppMyProfileIndexRoute
  '/pricing': typeof AppPricingIndexRoute
  '/user-settings': typeof AppUserSettingsIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/meetings/$meetingId': typeof AppMeetingsMeetingIdIndexRoute
  '/meetings/$meetingId/participant-details/$participantId': typeof AppMeetingsMeetingIdParticipantDetailsParticipantIdRoute
}
export interface FileRoutesByTo {
  '/reset-password': typeof ResetPasswordRoute
  '/analytics': typeof AppAnalyticsRoute
  '/settings': typeof AppSettingsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/guest-signup': typeof AuthGuestSignupRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/verify-code': typeof AuthVerifyCodeRoute
  '/demo/disallowed': typeof DemoDisallowedRoute
  '/': typeof AppIndexRoute
  '/auth': typeof AuthIndexRoute
  '/callback/zoom': typeof AppCallbackZoomRoute
  '/meetings/scheduled': typeof AppMeetingsScheduledRoute
  '/meetings/shared': typeof AppMeetingsSharedRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/users/$id': typeof AppUsersIdRoute
  '/admin-utterances': typeof AppAdminUtterancesIndexRoute
  '/company': typeof AppCompanyIndexRoute
  '/create-a-bot': typeof AppCreateABotIndexRoute
  '/linked-accounts': typeof AppLinkedAccountsIndexRoute
  '/live-monitors-alerts': typeof AppLiveMonitorsAlertsIndexRoute
  '/meetings': typeof AppMeetingsIndexRoute
  '/my-profile': typeof AppMyProfileIndexRoute
  '/pricing': typeof AppPricingIndexRoute
  '/user-settings': typeof AppUserSettingsIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/meetings/$meetingId': typeof AppMeetingsMeetingIdIndexRoute
  '/meetings/$meetingId/participant-details/$participantId': typeof AppMeetingsMeetingIdParticipantDetailsParticipantIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/guest-signup': typeof AuthGuestSignupRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/verify-code': typeof AuthVerifyCodeRoute
  '/demo/disallowed': typeof DemoDisallowedRoute
  '/_app/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/_app/callback/zoom': typeof AppCallbackZoomRoute
  '/_app/meetings/scheduled': typeof AppMeetingsScheduledRoute
  '/_app/meetings/shared': typeof AppMeetingsSharedRoute
  '/_app/settings_/billing': typeof AppSettingsBillingRoute
  '/_app/users/$id': typeof AppUsersIdRoute
  '/_app/admin-utterances/': typeof AppAdminUtterancesIndexRoute
  '/_app/company/': typeof AppCompanyIndexRoute
  '/_app/create-a-bot/': typeof AppCreateABotIndexRoute
  '/_app/linked-accounts/': typeof AppLinkedAccountsIndexRoute
  '/_app/live-monitors-alerts/': typeof AppLiveMonitorsAlertsIndexRoute
  '/_app/meetings/': typeof AppMeetingsIndexRoute
  '/_app/my-profile/': typeof AppMyProfileIndexRoute
  '/_app/pricing/': typeof AppPricingIndexRoute
  '/_app/user-settings/': typeof AppUserSettingsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/meetings/$meetingId/': typeof AppMeetingsMeetingIdIndexRoute
  '/_app/meetings/$meetingId/participant-details/$participantId': typeof AppMeetingsMeetingIdParticipantDetailsParticipantIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/reset-password'
    | '/analytics'
    | '/settings'
    | '/auth/forgot-password'
    | '/auth/guest-signup'
    | '/auth/login'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify'
    | '/auth/verify-code'
    | '/demo/disallowed'
    | '/'
    | '/auth/'
    | '/callback/zoom'
    | '/meetings/scheduled'
    | '/meetings/shared'
    | '/settings/billing'
    | '/users/$id'
    | '/admin-utterances'
    | '/company'
    | '/create-a-bot'
    | '/linked-accounts'
    | '/live-monitors-alerts'
    | '/meetings'
    | '/my-profile'
    | '/pricing'
    | '/user-settings'
    | '/users'
    | '/meetings/$meetingId'
    | '/meetings/$meetingId/participant-details/$participantId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/reset-password'
    | '/analytics'
    | '/settings'
    | '/auth/forgot-password'
    | '/auth/guest-signup'
    | '/auth/login'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify'
    | '/auth/verify-code'
    | '/demo/disallowed'
    | '/'
    | '/auth'
    | '/callback/zoom'
    | '/meetings/scheduled'
    | '/meetings/shared'
    | '/settings/billing'
    | '/users/$id'
    | '/admin-utterances'
    | '/company'
    | '/create-a-bot'
    | '/linked-accounts'
    | '/live-monitors-alerts'
    | '/meetings'
    | '/my-profile'
    | '/pricing'
    | '/user-settings'
    | '/users'
    | '/meetings/$meetingId'
    | '/meetings/$meetingId/participant-details/$participantId'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/reset-password'
    | '/_app/analytics'
    | '/_app/settings'
    | '/auth/forgot-password'
    | '/auth/guest-signup'
    | '/auth/login'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify'
    | '/auth/verify-code'
    | '/demo/disallowed'
    | '/_app/'
    | '/auth/'
    | '/_app/callback/zoom'
    | '/_app/meetings/scheduled'
    | '/_app/meetings/shared'
    | '/_app/settings_/billing'
    | '/_app/users/$id'
    | '/_app/admin-utterances/'
    | '/_app/company/'
    | '/_app/create-a-bot/'
    | '/_app/linked-accounts/'
    | '/_app/live-monitors-alerts/'
    | '/_app/meetings/'
    | '/_app/my-profile/'
    | '/_app/pricing/'
    | '/_app/user-settings/'
    | '/_app/users/'
    | '/_app/meetings/$meetingId/'
    | '/_app/meetings/$meetingId/participant-details/$participantId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  DemoDisallowedRoute: typeof DemoDisallowedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/demo/disallowed': {
      id: '/demo/disallowed'
      path: '/demo/disallowed'
      fullPath: '/demo/disallowed'
      preLoaderRoute: typeof DemoDisallowedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-code': {
      id: '/auth/verify-code'
      path: '/verify-code'
      fullPath: '/auth/verify-code'
      preLoaderRoute: typeof AuthVerifyCodeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/guest-signup': {
      id: '/auth/guest-signup'
      path: '/guest-signup'
      fullPath: '/auth/guest-signup'
      preLoaderRoute: typeof AuthGuestSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/user-settings/': {
      id: '/_app/user-settings/'
      path: '/user-settings'
      fullPath: '/user-settings'
      preLoaderRoute: typeof AppUserSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pricing/': {
      id: '/_app/pricing/'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AppPricingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-profile/': {
      id: '/_app/my-profile/'
      path: '/my-profile'
      fullPath: '/my-profile'
      preLoaderRoute: typeof AppMyProfileIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/': {
      id: '/_app/meetings/'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof AppMeetingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/live-monitors-alerts/': {
      id: '/_app/live-monitors-alerts/'
      path: '/live-monitors-alerts'
      fullPath: '/live-monitors-alerts'
      preLoaderRoute: typeof AppLiveMonitorsAlertsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/linked-accounts/': {
      id: '/_app/linked-accounts/'
      path: '/linked-accounts'
      fullPath: '/linked-accounts'
      preLoaderRoute: typeof AppLinkedAccountsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/create-a-bot/': {
      id: '/_app/create-a-bot/'
      path: '/create-a-bot'
      fullPath: '/create-a-bot'
      preLoaderRoute: typeof AppCreateABotIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company/': {
      id: '/_app/company/'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof AppCompanyIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin-utterances/': {
      id: '/_app/admin-utterances/'
      path: '/admin-utterances'
      fullPath: '/admin-utterances'
      preLoaderRoute: typeof AppAdminUtterancesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$id': {
      id: '/_app/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/billing': {
      id: '/_app/settings_/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/shared': {
      id: '/_app/meetings/shared'
      path: '/meetings/shared'
      fullPath: '/meetings/shared'
      preLoaderRoute: typeof AppMeetingsSharedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/scheduled': {
      id: '/_app/meetings/scheduled'
      path: '/meetings/scheduled'
      fullPath: '/meetings/scheduled'
      preLoaderRoute: typeof AppMeetingsScheduledRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/callback/zoom': {
      id: '/_app/callback/zoom'
      path: '/callback/zoom'
      fullPath: '/callback/zoom'
      preLoaderRoute: typeof AppCallbackZoomRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$meetingId/': {
      id: '/_app/meetings/$meetingId/'
      path: '/meetings/$meetingId'
      fullPath: '/meetings/$meetingId'
      preLoaderRoute: typeof AppMeetingsMeetingIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$meetingId/participant-details/$participantId': {
      id: '/_app/meetings/$meetingId/participant-details/$participantId'
      path: '/meetings/$meetingId/participant-details/$participantId'
      fullPath: '/meetings/$meetingId/participant-details/$participantId'
      preLoaderRoute: typeof AppMeetingsMeetingIdParticipantDetailsParticipantIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCallbackZoomRoute: typeof AppCallbackZoomRoute
  AppMeetingsScheduledRoute: typeof AppMeetingsScheduledRoute
  AppMeetingsSharedRoute: typeof AppMeetingsSharedRoute
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppUsersIdRoute: typeof AppUsersIdRoute
  AppAdminUtterancesIndexRoute: typeof AppAdminUtterancesIndexRoute
  AppCompanyIndexRoute: typeof AppCompanyIndexRoute
  AppCreateABotIndexRoute: typeof AppCreateABotIndexRoute
  AppLinkedAccountsIndexRoute: typeof AppLinkedAccountsIndexRoute
  AppLiveMonitorsAlertsIndexRoute: typeof AppLiveMonitorsAlertsIndexRoute
  AppMeetingsIndexRoute: typeof AppMeetingsIndexRoute
  AppMyProfileIndexRoute: typeof AppMyProfileIndexRoute
  AppPricingIndexRoute: typeof AppPricingIndexRoute
  AppUserSettingsIndexRoute: typeof AppUserSettingsIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppMeetingsMeetingIdIndexRoute: typeof AppMeetingsMeetingIdIndexRoute
  AppMeetingsMeetingIdParticipantDetailsParticipantIdRoute: typeof AppMeetingsMeetingIdParticipantDetailsParticipantIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppCallbackZoomRoute: AppCallbackZoomRoute,
  AppMeetingsScheduledRoute: AppMeetingsScheduledRoute,
  AppMeetingsSharedRoute: AppMeetingsSharedRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppUsersIdRoute: AppUsersIdRoute,
  AppAdminUtterancesIndexRoute: AppAdminUtterancesIndexRoute,
  AppCompanyIndexRoute: AppCompanyIndexRoute,
  AppCreateABotIndexRoute: AppCreateABotIndexRoute,
  AppLinkedAccountsIndexRoute: AppLinkedAccountsIndexRoute,
  AppLiveMonitorsAlertsIndexRoute: AppLiveMonitorsAlertsIndexRoute,
  AppMeetingsIndexRoute: AppMeetingsIndexRoute,
  AppMyProfileIndexRoute: AppMyProfileIndexRoute,
  AppPricingIndexRoute: AppPricingIndexRoute,
  AppUserSettingsIndexRoute: AppUserSettingsIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppMeetingsMeetingIdIndexRoute: AppMeetingsMeetingIdIndexRoute,
  AppMeetingsMeetingIdParticipantDetailsParticipantIdRoute:
    AppMeetingsMeetingIdParticipantDetailsParticipantIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthGuestSignupRoute: typeof AuthGuestSignupRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthVerifyCodeRoute: typeof AuthVerifyCodeRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthGuestSignupRoute: AuthGuestSignupRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthVerifyCodeRoute: AuthVerifyCodeRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  DemoDisallowedRoute: DemoDisallowedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
